// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/flag.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { FeatureFlagService } from "./flag_pb";

/**
 * @generated from rpc chalk.server.v1.FeatureFlagService.GetFeatureFlags
 */
export const getFeatureFlags = FeatureFlagService.method.getFeatureFlags;

/**
 * @generated from rpc chalk.server.v1.FeatureFlagService.GetTeamFeatureFlags
 */
export const getTeamFeatureFlags = FeatureFlagService.method.getTeamFeatureFlags;

/**
 * @generated from rpc chalk.server.v1.FeatureFlagService.GetFeatureFlag
 */
export const getFeatureFlag = FeatureFlagService.method.getFeatureFlag;

/**
 * @generated from rpc chalk.server.v1.FeatureFlagService.SetFeatureFlag
 */
export const setFeatureFlag = FeatureFlagService.method.setFeatureFlag;
